<template>
  <div class='menu-wrapper'>
    <template v-for="item in routes">
      <el-submenu v-show="item.sname!=='通知'" :index="item.sid" :key="item.sname" class="pItem" @click.native="openItem(item.sid)">
        <template slot="title"  >
          <i  :class="[item.sid!=currenOpen?item.sdesc:item.sdescon]"></i>
          <!-- <i :class="item.sdesc" v-show="item.sid!=currenOpen"></i>
          <i :class="item.sdescon"></i> -->
          <span>{{item.sname}}</span>
        </template>
        <template v-for="child in item.chlist">
          <router-link v-if="child.slink!=null && child.son==null" :to="child.slink" :key="child.sname">
            <el-menu-item :index="'/'+item.sid+'/'+child.sid" @click="handleClick(child.sid,item.sid)">
              <!-- <i class="el-icon-menu"></i> -->
              <span  >{{child.sname}}</span>
            </el-menu-item>
          </router-link>
          <div class="sonitem">
            <el-submenu v-if="child.son !=null" :index="child.sid">
              <template slot="title">{{child.sname}}</template>
              <template v-for="son in child.son">
                <router-link v-if="son.slink!=null" :to="son.slink" :key="son.sname">
                  <el-menu-item :index="'/'+item.sid+'/'+son.sid" @click="handleClick(item.sid,item.sid)">{{son.sname}}</el-menu-item>
                </router-link>
              </template>
            </el-submenu>
          </div>

        </template>

      </el-submenu>
    </template>
  </div>
</template>

<script>
export default {
  name: 'SidebarItem',
  props: {
    routes: {
      type: Array,
    }
  },
  data () {
    return {
      active: "",
      currenOpen: ''
    }
  },
  methods: {
    handleClick (sid, pid) {
      sessionStorage.setItem('sid', pid)
      this.active = sid;
    },
    openItem (sid) {
      setTimeout(() => {
        this.currenOpen = sid
      }, 250);

    }

  },
  created () {
    this.currenOpen = sessionStorage.getItem('sid')
  }
}
</script>


<style rel="stylesheet/scss" lang="scss" scoped>
// .el-menu-item {
//   background: #485077 !important;
//   color: #848bad !important;
// }
.el-menu .el-menu--inline {
  background-color: #ecf3f9 !important;
}
.menu-wrapper /deep/ .el-menu-item.is-active {
  background: #5677e6 !important;
}
/deep/ .el-submenu.is-opened .el-submenu__title {
  background: #5677e6 !important;
  color: white !important;
}
/deep/.el-submenu .el-submenu__title {
  color: rgb(205, 201, 201) !important;
}

.sonitem /deep/ .el-submenu.is-opened .el-submenu__title {
  background: #5677e6 !important;
  color: white !important;
}
.sonitem /deep/ .el-submenu .el-submenu__title {
  background: #485077 !important;
  color: rgb(205, 201, 201) !important;
}
.sonitem /deep/ .el-submenu .el-submenu__title i {
  color: rgb(205, 201, 201) !important;
}
.sonitem /deep/ .el-submenu.is-opened .el-submenu__title i {
  color: white !important;
}

>>> .el-submenu.is-opened .el-submenu__icon-arrow {
  color: white;
}
//菜单关闭
>>> .el-submenu > .el-submenu__title .el-submenu__icon-arrow {
  -webkit-transform: rotateZ(90deg);
  -ms-transform: rotate(90deg);
  transform: rotateZ(90deg);
}
/deep/ .el-submenu > .el-submenu__title .el-submenu__icon-arrow {
  -webkit-transform: rotateZ(90deg);
  -ms-transform: rotate(90deg);
  transform: rotateZ(90deg);
}
//菜单展开
>>> .el-submenu.is-opened > .el-submenu__title .el-submenu__icon-arrow {
  -webkit-transform: rotateZ(180deg);
  -ms-transform: rotate(180deg);
  transform: rotateZ(180deg);
}
/deep/ .el-submenu.is-opened > .el-submenu__title .el-submenu__icon-arrow {
  -webkit-transform: rotateZ(180deg);
  -ms-transform: rotate(180deg);
  transform: rotateZ(180deg);
}

>>> .el-submenu__icon-arrow {
  font-size: 14px;
  font-weight: bold;
}
/deep/ .el-submenu__icon-arrow {
  font-size: 14px;
  font-weight: bold;
}

/deep/ .el-submenu__title {
  background: #485077 !important;
  color: #e5e7eb !important;
}
.pItem /deep/ .el-icon-arrow-down:before {
  // 箭头图标变成三角形的图标
  content: "\e78f" !important;
}

// 自定义图标
.el-icon-my {
  background: url("../../imges/index.png") center no-repeat;
  background-size: cover;
}
.el-icon-my:before,
.el-icon-my-on:before {
  content: "\8d3a";
  font-size: 12px;
  visibility: hidden;
}
.el-icon-my-on {
  background: url("../../imges/index-on.png") center no-repeat;
  background-size: cover;
}

.htgl {
  background: url("../../imges/htgl.png") center no-repeat;
  background-size: cover;
}
.cggl {
  background: url("../../imges/cggl.png") center no-repeat;
  background-size: cover;
}

.project {
  background: url("../../imges/project.png") center no-repeat;
  background-size: cover;
}

.industrialCollege {
  background: url("../../imges/industrialCollege.png") center no-repeat;
  background-size: cover;
}
.industrialCollege-on {
  background: url("../../imges/industrialCollege-on.png") center no-repeat;
  background-size: cover;
}

.consortium {
  background: url("../../imges/consortium.png") center no-repeat;
  background-size: cover;
}
.consortium-on {
  background: url("../../imges/consortium-on.png") center no-repeat;
  background-size: cover;
}

.community {
  background: url("../../imges/community.png") center no-repeat;
  background-size: cover;
}
.community-on {
  background: url("../../imges/community-on.png") center no-repeat;
  background-size: cover;
}

.practiceCenter {
  background: url("../../imges/practiceCenter.png") center no-repeat;
  background-size: cover;
}
.practiceCenter-on {
  background: url("../../imges/practiceCenter-on.png") center no-repeat;
  background-size: cover;
}

.industrialCollege:before,
.industrialCollege-on:before,
.consortium:before,
.consortium-on:before,

.community:before,
.community-on:before,
.practiceCenter:before,
.practiceCenter-on:before,

.project:before,
.project-on:before,
.htgl:before,
.htgl-on:before,
.cggl:before,
.cggl-on:before,
.council:before,
.council-on:before,
.group:before,
.group-on:before,
.platform:before,
.platform-on:before,
.cooperation-on:before,
.cooperation:before,
.account-on:before,
.account:before,
.work-on:before,
.work:before,
.statistics-on:before,
.statistics:before,
.xtsz1:before,
.xtsz2:before {
  content: "\9879";
  font-size: 25px;
  visibility: hidden;
}
.bell-on:before,
.bell:before {
  content: "\9879";
  font-size: 20px;
  visibility: hidden;
}

.project-on {
  background: url("../../imges/project-on.png") center no-repeat;
  background-size: cover;
}
.htgl-on {
  background: url("../../imges/htgl-on.png") center no-repeat;
  background-size: cover;
}
.cggl-on {
  background: url("../../imges/cggl-on.png") center no-repeat;
  background-size: cover;
}

.council {
  background: url("../../imges/council.png") center no-repeat;
  background-size: cover;
}

.council-on {
  background: url("../../imges/council-on.png") center no-repeat;
  background-size: cover;
}

.group {
  background: url("../../imges/group.png") center no-repeat;
  background-size: cover;
}

.group-on {
  background: url("../../imges/group-on.png") center no-repeat;
  background-size: cover;
}
.platform {
  background: url("../../imges/platform.png") center no-repeat;
  background-size: cover;
}
.platform-on {
  background: url("../../imges/platform-on.png") center no-repeat;
  background-size: cover;
}

.cooperation {
  background: url("../../imges/cooperation.png") center no-repeat;
  background-size: cover;
}
.cooperation-on {
  background: url("../../imges/cooperation-on.png") center no-repeat;
  background-size: cover;
}
.account {
  background: url("../../imges/account.png") center no-repeat;
  background-size: cover;
}
.account-on {
  background: url("../../imges/account-on.png") center no-repeat;
  background-size: cover;
}
.work {
  background: url("../../imges/work.png") center no-repeat;
  background-size: cover;
}
.work-on {
  background: url("../../imges/work-on.png") center no-repeat;
  background-size: cover;
}
.statistics {
  background: url("../../imges/statistics.png") center no-repeat;
  background-size: cover;
}
.statistics-on {
  background: url("../../imges/statistics-on.png") center no-repeat;
  background-size: cover;
}
.bell {
  background: url("../../imges/news.png") center no-repeat;
  background-size: cover;
}
.bell-on {
  background: url("../../imges/news-on.png") center no-repeat;
  background-size: cover;
}
.xtsz1 {
  background: url("../../imges/xtsz1.png") center no-repeat;
  background-size: cover;
}
.xtsz2 {
  background: url("../../imges/xtsz2.png") center no-repeat;
  background-size: cover;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/SidebarItem.vue